import React from 'react'
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import { Tag } from 'antd'
import classNames from 'classnames'
import { PERIODS } from '../../../batches-mark-periods/helper/ListPeriods'

function ListPeriodsRow(props) {
    const { item, setType } = props
    const { name, product_types, brand, finish_periods } = item
    const { sewing_amount, marker, period_name, mark_date } = finish_periods
    const quantity = !!sewing_amount && (!!sewing_amount || sewing_amount === 0) ? sewing_amount : '-'
    const Date = !!mark_date ? moment(mark_date).format('HH:mm DD/MM/YYYY') : '-'

    const _generateLevel = (level) => {
        const color = level === 'highest' ? 'rgb(255 45 0)' : level === 'high' ? '#FFD300' : ''
        return <Tag className={classNames(`tag-${level}`)}
            color={color}>{level !== undefined ? level : 'medium'}</Tag>
    }
    const onClickType = (value) => {
        setType(value)
    }

    return (
        <tr className='PeriodsRow'>
            <td className='nameLo'>
                <Link to={`/batches/${item._id}`} className='w-100'>
                    {name}
                </Link>
                {
                    _generateLevel(item.level)
                }
            </td>
            <td className="ProductType">
                {!!product_types && product_types.length > 0 && product_types.map((type, index) => {
                    return type !== null &&
                        <span key={index} className="mr-2" onClick={() => onClickType([type])}>{type}</span>
                })
                }
                {!!brand &&
                    <div className="Brand">
                        <span className="mr-2" >{brand}</span>
                    </div>
                }
            </td>
            <td>{!!period_name ? PERIODS[period_name] : '-'}</td>
            <td>{quantity}</td>
            <td>{marker || '-'}</td>
            <td>{Date}</td>
        </tr>
    )
}

export default ListPeriodsRow